import { Slot } from "@radix-ui/react-slot";
import { cn } from "@scott/ui/utils/cn";
import type { ImgHTMLAttributes } from "react";

interface PaypalProps extends ImgHTMLAttributes<SVGElement> {
  asChild?: boolean;
}

const Paypal = ({ className, asChild = false }: PaypalProps) => {
  const Comp = asChild ? Slot : "svg";

  return (
    <Comp
      className={cn(className)}
      height="38"
      viewBox="0 0 640 168"
      width="111"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M120.9 16.1c-7.4-8.4-20.8-12-37.9-12H33.4c-3.5 0-6.5 2.5-7 6L5.7 141.2c-.4 2.6 1.6 4.9 4.2 4.9h30.7l7.7-48.8-.3 1.5c.5-3.5 3.5-6 7-6h14.6c28.6 0 51-11.6 57.6-45.3.2-1 .4-2 .5-2.9-.8-.4-.8-.4 0 0 1.9-12.4-.1-20.8-6.8-28.5"
        fill="#003087"
      />
      <path
        d="M492.3 46.4H458c-2.3 0-4.3 1.7-4.7 4l-13.9 87.9c-.3 1.7 1.1 3.3 2.8 3.3h17.6c1.6 0 3-1.2 3.3-2.8l3.9-24.9c.4-2.3 2.4-4 4.7-4h10.8c22.6 0 35.6-10.9 39-32.6 1.5-9.5.1-16.9-4.4-22.1-4.7-5.8-13.4-8.8-24.8-8.8m3.9 32.1c-1.9 12.3-11.3 12.3-20.4 12.3h-5.2l3.6-23c.2-1.4 1.4-2.4 2.8-2.4h2.4c6.2 0 12 0 15 3.5 2 2.2 2.5 5.3 1.8 9.6"
        fill="#009CDE"
      />
      <path
        d="M247.7 46.4h-34.3c-2.3 0-4.3 1.7-4.7 4l-13.9 87.9c-.3 1.7 1.1 3.3 2.8 3.3H214c2.3 0 4.3-1.7 4.7-4l3.7-23.7c.4-2.3 2.4-4 4.7-4h10.8c22.6 0 35.6-10.9 39-32.6 1.5-9.5.1-16.9-4.4-22.1-4.6-5.8-13.3-8.8-24.8-8.8m4 32.1c-1.9 12.3-11.3 12.3-20.4 12.3h-5.2l3.6-23c.2-1.4 1.4-2.4 2.8-2.4h2.4c6.2 0 12 0 15 3.5 1.9 2.2 2.5 5.3 1.8 9.6m98.5-.4h-16.4c-1.4 0-2.6 1-2.8 2.4l-.7 4.6-1.1-1.7c-3.6-5.2-11.5-6.9-19.4-6.9-18.1 0-33.6 13.7-36.6 33-1.6 9.6.7 18.8 6.1 25.2 5 5.9 12.2 8.3 20.7 8.3 14.6 0 22.7-9.4 22.7-9.4l-.7 4.6c-.3 1.7 1.1 3.3 2.8 3.3h14.8c2.3 0 4.3-1.7 4.7-4l8.9-56.2c.1-1.6-1.2-3.2-3-3.2m-22.9 32c-1.6 9.4-9 15.7-18.5 15.7-4.8 0-8.6-1.5-11-4.4-2.4-2.9-3.3-7-2.6-11.5 1.5-9.3 9-15.8 18.4-15.8 4.7 0 8.4 1.5 10.9 4.5 2.6 2.8 3.6 6.9 2.8 11.5"
        fill="#003087"
      />
      <path
        d="M594.7 78.1h-16.4c-1.4 0-2.6 1-2.8 2.4l-.7 4.6-1.1-1.7c-3.6-5.2-11.5-6.9-19.4-6.9-18.1 0-33.6 13.7-36.6 33-1.6 9.6.7 18.8 6.1 25.2 5 5.9 12.2 8.3 20.7 8.3 14.6 0 22.7-9.4 22.7-9.4l-.7 4.6c-.3 1.7 1.1 3.3 2.8 3.3H584c2.3 0 4.3-1.7 4.7-4l8.9-56.2c.2-1.6-1.1-3.2-2.9-3.2m-22.8 32c-1.6 9.4-9 15.7-18.5 15.7-4.8 0-8.6-1.5-11-4.4-2.4-2.9-3.3-7-2.6-11.5 1.5-9.3 9-15.8 18.4-15.8 4.7 0 8.4 1.5 10.9 4.5 2.5 2.8 3.5 6.9 2.8 11.5"
        fill="#009CDE"
      />
      <path
        d="M437.6 78.1h-16.5c-1.6 0-3.1.8-3.9 2.1l-22.8 33.5-9.6-32.2c-.6-2-2.5-3.4-4.6-3.4H364c-2 0-3.3 1.9-2.7 3.8l18.2 53.3-17.1 24.1c-1.3 1.9 0 4.5 2.3 4.5h16.5c1.6 0 3-.8 3.9-2L440 82.6c1.3-1.9 0-4.5-2.4-4.5"
        fill="#003087"
      />
      <path
        d="M614.1 48.8L600 138.3c-.3 1.7 1.1 3.3 2.8 3.3H617c2.3 0 4.3-1.7 4.7-4l13.9-87.9c.3-1.7-1.1-3.3-2.8-3.3H617c-1.5 0-2.7 1-2.9 2.4"
        fill="#009CDE"
      />
      <path
        d="M120.9 16.1c-7.4-8.4-20.8-12-37.9-12H33.4c-3.5 0-6.5 2.5-7 6L5.7 141.2c-.4 2.6 1.6 4.9 4.2 4.9h30.7l7.7-48.8-.3 1.5c.5-3.5 3.5-6 7-6h14.6c28.6 0 51-11.6 57.6-45.3.2-1 .4-2 .5-2.9-.8-.4-.8-.4 0 0 1.9-12.4-.1-20.8-6.8-28.5"
        fill="#003087"
      />
      <path
        d="M56.5 44.8c.3-2.1 1.7-3.8 3.5-4.6.8-.4 1.7-.6 2.7-.6h38.9c4.6 0 8.9.3 12.8.9l3.3.6c1.1.2 2.1.5 3.1.8.5.1 1 .3 1.5.5 1.9.6 3.7 1.4 5.4 2.3 1.9-12.4 0-20.9-6.7-28.5-7.4-8.4-20.8-12-37.9-12H33.3c-3.5 0-6.5 2.5-7 6l-20.6 131c-.4 2.6 1.6 4.9 4.2 4.9h30.7l7.7-48.8 8.2-52.5z"
        fill="#003087"
      />
      <path
        d="M127.6 44.7c-.2 1-.3 1.9-.5 2.9-6.5 33.6-29 45.3-57.6 45.3H55c-3.5 0-6.4 2.5-7 6l-7.5 47.3-2.1 13.4c-.4 2.3 1.4 4.3 3.7 4.3h25.8c3.1 0 5.7-2.2 6.1-5.2l.3-1.3 4.9-30.9.3-1.7c.5-3 3.1-5.2 6.1-5.2h3.9c25 0 44.6-10.2 50.4-39.6 2.4-12.3 1.2-22.6-5.2-29.8-1.9-2.3-4.3-4.1-7.1-5.5"
        fill="#009CDE"
      />
      <path
        d="M120.8 41.9c-1-.3-2-.6-3.1-.8l-3.3-.6c-3.9-.6-8.2-.9-12.8-.9h-39c-1 0-1.9.2-2.7.6-1.8.9-3.1 2.6-3.5 4.6l-8.3 52.5-.1 1.5c.5-3.5 3.5-6 7-6h14.6c28.6 0 51-11.6 57.6-45.3.2-1 .4-2 .5-2.9-1.7-.9-3.5-1.6-5.4-2.3-.5-.1-1-.2-1.5-.4"
        fill="#012169"
      />
    </Comp>
  );
};

Paypal.displayName = "Paypal";

export { Paypal };
